module.exports = __webpack_public_path__ + "static/img/gongyinglian-bottom.f1372fd0.png";